// One address for every web caller. Production defaults to the serving origin.
export function resolveApiBaseUrl(value, production) {
  const base = (value || (production ? '/api' : 'https://www.riitii.com/api')).trim().replace(/\/+$/, '');
  if (base.startsWith('/') && !base.startsWith('//')) return base;
  const url = new URL(base);
  if (url.username || url.password || !['http:', 'https:'].includes(url.protocol) ||
      (production && (url.protocol !== 'https:' || /^(localhost|127\.|0\.|\[::1\])/i.test(url.hostname)))) {
    throw new Error('Configure a public HTTPS backend URL or /api for production');
  }
  return base;
}

export default resolveApiBaseUrl(process.env.REACT_APP_BASE_URL || process.env.REACT_APP_API_URL, process.env.NODE_ENV === 'production');
